import React, {useContext, useEffect, useState} from 'react';

import AuthContext from "../Validation/AuthContext";
import removeImg from "../Images/delate.svg"
import ReactTooltip from 'react-tooltip';

const VariableItem = ({name, type, removeVar, typeOfComponent}) => {

    // const {ID} = useContext(AuthContext)
    const [color, setColor] = useState("")


    const remove = (e) => {

        if (typeOfComponent === "name") {
            // api.removeName({userId: ID, projectId: window.location.pathname.slice(1), name: name})
            removeVar(name)
        }
        if (typeOfComponent === "variable") {
            // api.removeVariable({userId: ID, projectId: window.location.pathname.slice(1), name: name})
            removeVar(name)
        }
    }


    useEffect(()=>{
        if(type === "integer"){
            setColor("#288aad")
        }
        if(type === "bool"){
            setColor("#cc2f41")
        }
        if(type === "string"){
            setColor("#e83881")
        }
        if(type === "float"){
            setColor("#28ad54")
        }

    },[])


    return (
        <>

            <div className="variableItem">

                <div   data-tip={name} className="globalName">{name.length >8 ? name.substring(0,8) +"..." : name}
                   <ReactTooltip />
                </div>
                <div className="globalType">
                    <div style={{background: color,
                        width: "60px",
                        padding: "2px",
                        borderRadius: '2px',
                        textAlign:"center",
                        fontWeight:"bold",
                        fontSize:"1rem"
                    }}>
                        {type}
                    </div>

                </div>
                <button className="VariableRemoveBtn"
                        onClick={remove}><img
                    style={{filter: "invert(1)", width: "28px"}}
                    src={removeImg}/></button>
            </div>
        </>
    );
};

export default VariableItem;